<template>
  <div style="display: none"></div>
</template>

<script>
import XLSX from 'xlsx';
import { track } from '@/modules/Flexigo/helpers/rum';

export default {
  name: 'ExcelDownloader',
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    fileName: {
      type: String,
      required: true,
    },
    sheetName: {
      type: String,
      default: 'Sheet1',
    },
  },
  methods: {
    download() {
      if (!this.data.length) return;
      // Datadog RUM: named by the chart component that uses this downloader
      track(`export:excel:${this.$vnode?.context?.$options.name || 'unknown'}`);

      const ws = XLSX.utils.json_to_sheet(this.data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, this.sheetName);

      const today = new Date().toISOString().split('T')[0];
      const filename = `${this.fileName}_${today}.xlsx`;

      XLSX.writeFile(wb, filename);
    },
  },
};
</script>
